import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-email-faq",
  "use": "icon-email-faq-usage",
  "viewBox": "0 0 14 9.692",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 9.692\" id=\"icon-email-faq\">\n  <path id=\"icon-email-faq_np_email_1740173_000000\" d=\"M12.077,23a1.038,1.038,0,0,0-.572.174l6.063,5.744a.6.6,0,0,0,.875,0L24.5,23.174A1.038,1.038,0,0,0,23.923,23Zm-1.01.74a1.144,1.144,0,0,0-.067.376v7.46a1.141,1.141,0,0,0,.174.611l4.285-4.28Zm13.865,0L20.552,27.9l4.274,4.285A1.141,1.141,0,0,0,25,31.576v-7.46a1.144,1.144,0,0,0-.067-.376Zm-4.9,4.661-1.094,1.038a1.355,1.355,0,0,1-1.862,0l-1.094-1.032-4.24,4.229a1.049,1.049,0,0,0,.337.056H23.923a1.049,1.049,0,0,0,.337-.056Z\" transform=\"translate(-11 -23)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/email-faq.svg
// module id = 130
// module chunks = 0 1 2